/**
 * The medical demo's PATIENT screen is the real guest flow and has no header,
 * so its Reset Demo lives in a fixed pill — the same self-hiding pattern the
 * other demo switchers use. It renders ONLY on a `MEDDEMO-` card, so a real
 * clinic's patient never sees it.
 */
import { useLocation } from 'react-router-dom';
import MedDemoReset, { isMedDemoPatientPath } from './MedDemoReset';

export default function MedDemoPatientReset() {
    const { pathname } = useLocation();
    if (!isMedDemoPatientPath(pathname)) return null;
    return <MedDemoReset variant="floating" />;
}
